import { useEffect, useState } from "react";

export const useIsComponentMounted = () => {
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  useEffect(() => setIsComponentMounted(true), []);

  return isComponentMounted;
};
